import { createReducer, on } from "@ngrx/store";
import { EstruturaRetornoDadosOutputDto } from "src/app/domain/DTOs/output/estrutura-retorno-dados.output.dto";
import { obterArquivoCadernoPorId, obterArquivoCadernoPorIdFailure, obterArquivoCadernoPorIdFinish, obterArquivoCadernoPorIdSuccess } from "../../actions/Caderno/obter-arquivo-caderno-por-id.action";
import { ArquivoCadernoOutputDto } from "src/app/domain/DTOs/output/jornal/arquivo-caderno.output.dto";

export interface ObterArquivoCadernoPorIdState {
    response: EstruturaRetornoDadosOutputDto<ArquivoCadernoOutputDto> | null;
    error: string[] | null;
}

export const initialState: ObterArquivoCadernoPorIdState = {
    response: null,
    error: null,
};

export const ObterArquivoCadernoPorIdReducer = createReducer(
    initialState,
    on(obterArquivoCadernoPorId, state => ({ ...state, error: null })),
    on(obterArquivoCadernoPorIdSuccess, (state, { response }) => ({ ...state, response, error: null })),
    on(obterArquivoCadernoPorIdFailure, (state, { response }) => ({ ...state, response: null, error: response.erros })),
    on(obterArquivoCadernoPorIdFinish, state => ({ ...state, response: null, error: null }))
);
